import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';
import values from 'lodash/values';
import _xor from 'lodash/xor';

import moment from 'moment';
import qs from 'qs';
import {LOCATION_CHANGE} from 'react-router-redux';

import http from '../shared/http';
import endpoints from '../../config/endpoints';

import intl from '../shared/intl';
import checkPermissions from '../shared/check-permissions';

import { default as createCalendar } from '../shared/calendar';
import createFilters from '../shared/filters';

const calendar = createCalendar({
	namespace: 'garantForecast',
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment().subtract(13, 'day').format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

// actions types
const FETCH_DATA_SUCCESS = 'garant-forecast/fetch-data-success';
const FETCH_DATA_ERROR = 'garant-forecast/fetch-data-error';

const TOGGLE_PROGRESS_BAR = 'garant-forecast/toggle-progress-bar';
const TOGGLE_SHOW_ALL = 'garant-forecast/toggle-show-all';
const TOGGLE_PERIOD_SWITCH = 'garant-forecast/TOGGLE_PERIOD_SWITCH';
const CLEAR = 'garant-forecast/clear';

const FETCH_EXPANDED_DATA_SUCCESS = 'garant-forecast/FETCH_EXPANDED_DATA_SUCCESS';

const TOGGLE_EXPANDED_ITEM = 'garant-forecast/TOGGLE_EXPANDED_ITEM';

// permissions
export const allowedPermissions = {
	view: 'garant_forecast_view'
};

const filters = createFilters({
	namespace: 'garantForecast',
	stateNodeName: 'filters',
	queryBuildFunc: () => '',
	listOfFilters: [
		{
			name: 'offers',
			title: 'Offers',
			placeholder: 'Add offers',
			value: [],
			multi: true,
			shouldInverse: false,
			shouldShowInverseControl: false,
			options: {
				type: 'dynamic',
				source: endpoints.LOOKUPS.OFFERS
			}
		},
		{
			name: 'affiliates',
			title: 'Affiliates',
			placeholder: 'Add affiliates',
			value: [],
			multi: true,
			shouldInverse: true,
			shouldShowInverseControl: true,
			options: {
				type: 'dynamic',
				source: endpoints.LOOKUPS.AFFILIATES
			}
		},
		{
			name: 'country_ids',
			title: 'Countries',
			placeholder: 'Add country',
			value: [],
			multi: true,
			shouldInverse: false,
			shouldShowInverseControl: false,
			options: {
				type: 'dynamic',
				source: endpoints.LOOKUPS.LOCATIONS_WITH_TRAFFIC
			}
		},
		{
			name: 'admins',
			title: 'Managers',
			placeholder: 'Managers',
			value: [],
			multi: true,
			shouldInverse: false,
			shouldShowInverseControl: false,
			options: {
				type: 'dynamic',
				source: endpoints.LOOKUPS.ADMINS + '?role=manager'
			}
		},
		{
			name: 'is_active_status',
			title: 'Is active status',
			placeholder: 'Is active status',
			value: [],
			multi: true,
			shouldInverse: false,
			shouldShowInverseControl: false,
			options: {
				type: 'provided',
				source: ['true', 'false'].map(reg => ({
					value: reg,
					label: reg
				}))
			}
		},
		{
			name: 'traffic_source',
			title: 'Traffic source',
			placeholder: 'Select traffic source',
			value: [],
			multi: true,
			shouldInverse: false,
			shouldShowInverseControl: false,
			options: {
				type: 'static',
				source: 'root.lists.traffic-sources'
			}
		}
	]
});

// initial state
const initialState = {
	data: null,
	periodSwitch: null,
	showAllEnabled: false,
	calendar: calendar.initialState,
	table: {
		columns: {
			manager: {
				index: ['manager', 'affiliate', 'country', 'offer'],
				title: 'Manager/Affiliate/Geo/Offer',
				className: 'fixed-col width-200 sticky-top-0'
			},
			id: {
				index: 'id',
				title: 'ID',
				className: 'ordinary-col',
				isSortable: true
			},
			start_end_duration: {
				index: 'start',
				title: 'Start/End/Duration',
				className: 'ordinary-col',
				isSortable: true
			},
			// end: {
			// 	index: 'end',
			// 	title: 'End',
			// 	className: 'ordinary-col',
			// 	isSortable: true
			// },
			target_percent: {
				index: 'target_percent',
				title: 'Target percent',
				className: 'ordinary-col',
				isSortable: true
			},
			payout_amount: {
				index: 'payout_amount',
				title: 'payout amount',
				className: 'ordinary-col',
				isSortable: true
			},
			start_leads_count: {
				index: 'start_leads_count',
				title: 'Start leads',
				className: 'ordinary-col',
				isSortable: true
			},
			sid: {
				index: 'sid',
				title: 'Sid',
				className: 'ordinary-col'
			},
			// duration: {
			// 	index: 'duration',
			// 	title: 'duration',
			// 	className: 'ordinary-col'
			// },
			is_in_progress: {
				index: 'is_in_progress',
				title: 'Активен?',
				className: 'ordinary-col'
			}
		}
	},
	filters: filters.initialState,
	showProgressBar: false,
	expandedIds: [],
	expandedData: [],
	error: false
};

// actions
export const actions = Object.assign(
	{
		fetchData: () => (dispatch, getState) => {

			if (document.isLoading) {
				return;
			}

			document.isLoading = true;

			dispatch(actions.toggleProgressBar());
			return request(getState)(dispatch)
				.then(action => {
					document.isLoading = false;
				});
		},

		clear: () => (dispatch, getState) => {
			dispatch(actions.toggleProgressBar());
			dispatch({ type: CLEAR });
			request(getState)(dispatch);
		},
		toggleShowAll: () => (dispatch, getState) => {

			dispatch({
				type: TOGGLE_SHOW_ALL
			});
			dispatch(actions.toggleProgressBar());

			return request(getState)(dispatch);
		},
		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		}),
		togglePeriodSwitch: (payload) => (dispatch, getState) => {
			dispatch({
				type: TOGGLE_PERIOD_SWITCH,
				payload
			});
			dispatch(actions.toggleProgressBar());

			return request(getState)(dispatch);
		},
		toggleExpandedItem: (id) => (dispatch, getState) => {
			dispatch({
				type: TOGGLE_EXPANDED_ITEM,
				payload: id
			});
			return request(getState, true)(dispatch);
		}
	},
	calendar.actions,
	filters.actions
);

// reducers
const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => ({
			...initialState
		}),
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: action.payload.data.rows,
			dates: action.payload.data.dates,
			showProgressBar: false,
			error: false
		}),
		[FETCH_EXPANDED_DATA_SUCCESS]: (state, action) => ({
			...state,
			expandedData: action.payload.data
		}),
		[TOGGLE_EXPANDED_ITEM]: (state, action) => ({
			...state,
			expandedIds: [..._xor(state.expandedIds, [ action.payload ])]
		}),
		[CLEAR]: (state, action) => ({ ...state, initialState }),
		[TOGGLE_PERIOD_SWITCH]: (state, action) => ({ ...state, periodSwitch: action.payload }),
		[FETCH_DATA_ERROR]: (state, action) => ({ ...state, error: true, showProgressBar: false }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
		[TOGGLE_SHOW_ALL]: state => ({ ...state, showAllEnabled: !state.showAllEnabled })
	},
	calendar.reducers,
	filters.reducers
);

// reducers
export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.garantForecast.data,
	getExpandedData: state => state.garantForecast.expandedData,
	getDates: state => state.garantForecast.dates,
	getCalendar: state =>
		calendar.selectors.getCalendar(
			state => state.garantForecast.calendar, state => state
		)(state),
	getTable: state => {
		const { table, data, expandedData } = state.garantForecast;
		const items = state.garantForecast.data ? data : [];
		const rows = [];

		for (const item of items) {
			rows.push(item);
			rows.push(...expandedData.filter(ed => ed.id === item.id));
		}

		return {
			headers: values(table.columns),
			rows: rows,
			sortedColumn: table.sortByColumn
		};
	},
	getFilters: state => filters.selectors.getFilters(
		state => state.garantForecast.filters,
		state => state
	)(state),
	getManualApproveInitialValues: state => state.garantForecast.manualApproveInitialValues,
	getIntl: state => intl(state),
	getProgressBar: state => state.garantForecast.showProgressBar,
	getPeriodSwitch: state => state.garantForecast.periodSwitch,
	getShowAllEnabled: state => state.garantForecast.showAllEnabled,
	getExpandedIds: state => state.garantForecast.expandedIds,
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.garantForecast.error
};

const request = ( getState, isExpanded ) => {
	const query = {};

	if (selectors.getShowAllEnabled(getState())) {
		query.is_showed_all = true;
	}
	query.period = selectors.getPeriodSwitch(getState());
	const calendar = selectors.getCalendar(getState()).value;
	const selectedFilters = selectors.getFilters(getState()).selectedFilters;

	const expandedIds = selectors.getExpandedIds(getState());
	let url = endpoints.GARANT_FORECAST.BASE;

	if (isExpanded) {
		query.expandedIds = expandedIds;
		url = endpoints.GARANT_FORECAST.EXPANDED;
	}

	for (const filter of selectedFilters) {
		if (!filter.value || !filter.value[0] || !filter.name) {
			continue;
		}
		query.filters = query.filters || {};
		query.inverse_filters = query.inverse_filters || {};

		query[filter.shouldInverse ? 'inverse_filters' : 'filters'][filter.name]  = filter.value.map(val => val.value);
	}
	query.date_range = { start: `${calendar.start}T00:00:00Z`, end: `${calendar.end}T23:59:59Z` };

	return http({
		url: `${url}?${qs.stringify(query)}`,
		method: 'get',
		actions: [ isExpanded ? FETCH_EXPANDED_DATA_SUCCESS : FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
	});
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/garant-forecast/index.js